"use strict";
/*
 * Created on 26.02.2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var NumberGreaterThanValidator_1 = require("../../core/model/data-dictionary/validators/NumberGreaterThanValidator");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Promo4Member credits for purchased amount of item (PROMO-289).
 * @author Radek Beran
 */


var MemberCredits =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(MemberCredits, _DomainObject_1$Domai);

  /**
   * Creates new instance of member credits.
   * If credits are enabled, amountForPurchase or healthyAmountForPurchase should be filled.
   * @param enabled whether non-null member credits are defined for item ("Extra Loyalty Credits")
   * @param amountForPurchase number of credits achieved for purchase of promoted item (0, 1, 2, ...)
   * ("Member Credit Amount")
   * @param healthyAmountForPurchase number of credits achieved for purchase of promoted "healthy" item (0, 1, 2, ...) (PROMO-507)
   * ("Healthy Credit Amount")
   * @param purchaseQuantity quantity of purchased product that is necessary to achieve given amount of credits (1, 2, ...)
   * ("Product Quantity")
   */
  function MemberCredits(enabled, amountForPurchase, healthyAmountForPurchase, purchaseQuantity) {
    var _this;

    _classCallCheck(this, MemberCredits);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MemberCredits).call(this));
    _this.enabled = enabled;
    _this.amountForPurchase = amountForPurchase;
    _this.healthyAmountForPurchase = healthyAmountForPurchase;
    _this.purchaseQuantity = purchaseQuantity;
    return _this;
  }

  _createClass(MemberCredits, null, [{
    key: "fromMat",
    value: function fromMat(mat) {
      return new MemberCredits(mat.enabled, mat.amountForPurchase, mat.healthyAmountForPurchase, mat.purchaseQuantity);
    }
  }]);

  return MemberCredits;
}(DomainObject_1.DomainObject);

exports.MemberCredits = MemberCredits;
MemberCredits.EMPTY = new MemberCredits(false, null, null, null);
MemberCredits.EMPTY_DOC = Object.assign({}, MemberCredits.EMPTY);

MemberCredits.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(MemberCredits.name);
  return {
    enabled: builder.bool('enabled'),
    amountForPurchase: builder.opt(builder.num('amountForPurchase', new NumberGreaterThanValidator_1.NumberGreaterThanValidator(0, true))),
    healthyAmountForPurchase: builder.opt(builder.num('healthyAmountForPurchase', new NumberGreaterThanValidator_1.NumberGreaterThanValidator(0, true))),
    purchaseQuantity: builder.opt(builder.num('purchaseQuantity', new NumberGreaterThanValidator_1.NumberGreaterThanValidator(0, false)))
  };
}();